import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'

gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase)

/**
 *   - data-anim-trigger: parent element for the animation
 *   - data-anim: animation type (e.g., 'heading', 'fade') 
 *   - data-anim-delay: delay before animation starts (in seconds)
 */

CustomEase.create("smooth", "M0,0 C0.38,0.005 0.215,1 1,1")

export const initInviewAnimations = () => {

  const animParents = document.querySelectorAll('[data-anim-trigger]')

	if (animParents.length === 0 || window.isLivePreview) return

	document.fonts.ready.then(() => {
		animParents.forEach((element) => {
			const animOffset = element.dataset.animOffset
			const animElements = element.querySelectorAll('[data-anim]')
			createTimeline(element, animElements, animOffset)
		})
	})
}

const createTimeline = (parent, animElements, offset = '80%') => {
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: parent,
			start: `top ${offset}`,
			invalidateOnRefresh: true,
			once: true
		}
	})

	parent.dataset.animTrigger = 'ready'

	animElements.forEach((element) => {
		const type = element.dataset.anim
		const delay = element.dataset.animDelay

		createAnimation(tl, element, type, delay)
	})
}

const createAnimation = (tl, element, type, delay = 0) => {

  switch (type) {
		
		case 'fade':

			tl.fromTo(element, {
				y: 74,
				opacity: 0
			}, {
				y: 0,
				opacity: 1,
				duration: 1,
				ease: 'power2.out',
				willChange: 'transform, opacity',
			}, delay)

      break
  }
}